export const formatDate = (dateString: string | undefined | null): string => {
  if (!dateString) {
    return 'N/A';
  }
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 'Date invalide';
    }
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  } catch (error) {
    return 'Date invalide';
  }
};

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
};

export const formatDateTime = (dateString: string | undefined | null): string => {
  if (!dateString) {
    return 'N/A';
  }
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 'Date invalide';
    }
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  } catch (error) {
    return 'Date invalide';
  }
};

export const formatPhoneNumber = (phoneNumber: string | undefined | null): string => {
  if (!phoneNumber) {
    return 'N/A';
  }

  const cleaned = ( '' + phoneNumber).replace(/\D/g, '');
  const match = cleaned.match(/^(33|0)(\d{9})$/);

  if (match) {
    const international = '33' + match[2];
    const part1 = international.substring(2, 3);
    const part2 = international.substring(3, 5);
    const part3 = international.substring(5, 7);
    const part4 = international.substring(7, 9);
    const part5 = international.substring(9, 11);
    return `+33 ${part1} ${part2} ${part3} ${part4} ${part5}`;
  }

  return phoneNumber;
};

export const toLocalDateInput = (d: string | Date) => {
  const date = new Date(d);
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return date.toISOString().slice(0,10);
};